import axios from '../utils/index';
import { Pat } from '@/typings/request';

const businessAdminUserApi = {
    async getBusinessAdminUserList(params: Pat) {
        return axios.get(`/business-admin-user/list`, { params });
    },
    async getBusinessAdminUserDetail(businessAdminUserId: string) {
        return axios.get(`/business-admin-user/detail/${businessAdminUserId}`);
    },
    async createBusinessAdminUser(data: Pat) {
        return axios.post(`/business-admin-user`, data, { timeout: 120000 });
    },
    async updateBusinessAdminUser(businessAdminUserId: string, data: Pat) {
        return axios.put(`/business-admin-user/${businessAdminUserId}`, data, { timeout: 120000 });
    },
    async deleteBusinessAdminUser(businessAdminUserId: string) {
        return axios.delete(`/business-admin-user/${businessAdminUserId}`);
    },
};

export default businessAdminUserApi;
